export default [
  [
    {
      id: 'companyType',
      type: 10,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'บริษัท *' } },
    },
  ], [
    {
      id: 'fullname',
      type: 0,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'ชื่อ - นามสกุล *' } },
    }, {
      id: 'fleetCode',
      type: 8,
      span: 8,
      offset: 0,
      label: 'Fleet *',
      props: { padding: '8px 0', width: '100%', title: { text: 'Fleet' } },
    }, {
      id: 'email',
      type: 0,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'อีเมล์' } },
    },
  ], [
    {
      label: 'department',
      id: 'department',
      type: 0,
      span: 8,
      offset: 0,
      props: {
        padding: '8px 0', width: '100%', title: { text: 'หน่วยงาน' }, input: { disabled: true, value: 'พนักงานขับรถ' },
      },
    }, {
      label: 'วันที่เริ่มงาน *',
      id: 'startDate',
      type: 7,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'วันที่เริ่มงาน' } },
    }, {
      label: 'nationalId',
      id: 'nationalId',
      type: 0,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'รหัสประชาชน' } },
    }, {
      label: 'licenseId',
      id: 'licenseId',
      type: 0,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'รหัสใบขับขี่ *' } },
    }, {
      label: 'วันหมดอายุใบขับขี่ *',
      id: 'licenseExpire',
      type: 7,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'วันหมดอายุใบขับขี่' } },
    },
  ], [
    {

      label: 'phonenumber',
      id: 'phonenumber',
      type: 0,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'เบอร์โทรศัพท์' } },
    },
    {
      label: 'วันที่ลาออก',
      id: 'quitDate',
      type: 7,
      span: 8,
      offset: 0,
      props: { disabled: true },
    },
    {
      label: 'salary',
      id: 'salary',
      type: 0,
      span: 8,
      offset: 0,
      dataType: 'float',
      props: { padding: '8px 0', width: '100%', title: { text: 'เงินเดือน *' } },
    },
    {
      label: 'bankAccountNumber',
      id: 'bankAccountNumber',
      type: 0,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'เลขที่บัญชี' } },
    },
    {
      label: 'bankName',
      id: 'bankName',
      type: 0,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'ธนาคาร' } },
    },
    {
      label: 'insuranceNumber',
      id: 'insuranceNumber',
      type: 0,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'เลขที่ประกันสังคม' } },
    },
    {
      label: 'วันเกิด',
      id: 'birthDate',
      type: 7,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'วันเกิด' } },
    },
  ],
]
